// extracted by mini-css-extract-plugin
export default {"section":"Section_section__Z2PLw","iconsContainer":"Section_iconsContainer__01e8k","trackerBox":"Section_trackerBox__rTwnX"};